import ListFilter from 'components/common/list-filter/ListFilter';
import withCards, { CardContext } from 'hoc/withCards';
import { PermissionContext } from 'hoc/withPermission';
import React, { useContext } from 'react'
import { Link } from 'react-router-dom';
import CriterionClassDisciplineCard from '../components/CriterionCard';
import CriterionListFilter from '../components/CriterionListFilter';
import criterionClassDisciplineService from '../services'
import { CriterionClassDisciplineList } from '../types';

type CriterionClassDisciplineListPageProps = {
  renderLoading: () => React.ReactNode;
  onChangeForm: (e: any) => void;
};

const CriterionClassDisciplineListPage: React.FC<CriterionClassDisciplineListPageProps> = ({ renderLoading, onChangeForm }) => {
  const { cards } = useContext(CardContext)
  const { hasPermission } = useContext(PermissionContext)

  return (
    <>
      {hasPermission('activities.add_criterionclassdiscipline') && (
        <div className="mb-3">
          <Link className="btn btn-primary" to="/criterios-turma-disciplina/new">
            CADASTRAR CRITÉRIO X TURMA/DISCIPLINA
          </Link>
        </div>
      )}
      <CriterionListFilter onValueChange={onChangeForm} />
      <div className="card-deck">
        {renderLoading() ||
          cards.map((card: CriterionClassDisciplineList /* for now */) => (
            <CriterionClassDisciplineCard key={card.id} criterionClassDiscipline={card} />
          ))}
      </div>
    </>
  )
}

export default withCards({
  fetch: criterionClassDisciplineService.list,
  title: 'Critério x Turma/Disciplina',
  paginated: true,
  noResultsText: 'Nenhum critério encontrado.'
})(CriterionClassDisciplineListPage)
